module.exports = __webpack_public_path__ + "img/exam-zh-original.7a543361.webp";